import React, { FunctionComponent as FC } from 'react';
import { PietroskiInput } from './styled';

export interface InputProps {
    type?: string;
    darkMode?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string;
    width?: string;
    heigth?: string;
    margin?: string;
    textPadding?: string;
}

const Input: FC<InputProps> = (props: InputProps) => {

    const { 
        type = "text",
        onChange = () => {}, 
        value = "",
    } = props;

    return (
            <PietroskiInput {...props}
                type={type ? `${type}` : "text"} 
                onChange={onChange}
                value={value}
                className={props.darkMode ? "dark" : "bright"}                    
            />
    )
}

export default Input;